import { DateRange } from "@/dateRanges/dateRanges";
import {
  endOfDay,
  isBefore,
  isSunday,
  isWeekend,
  max,
  min,
  nextSaturday,
  nextSunday,
  startOfDay
} from "date-fns";

export type Weekends = [Date, Date][];

const getWeekends = (dateRange: DateRange): Weekends => {
  const searchStart = dateRange.value.from();
  const searchEnd = dateRange.value.to();

  const weekends: Weekends = []

  const earliestWeekendDayWithinInterval = isWeekend(searchStart) ? searchStart : nextSaturday(searchStart);

  let weekendDay = earliestWeekendDayWithinInterval

  while (isBefore(weekendDay, searchEnd)) {
    const earliestWeekendTimeWithinInterval = max([searchStart, startOfDay(weekendDay)]);
    const endOfWeekend = endOfDay(isSunday(weekendDay) ? weekendDay : nextSunday(weekendDay));
    const latestWeekendTimeWithinInterval = min([searchEnd, endOfWeekend]);

    weekends.push([earliestWeekendTimeWithinInterval, latestWeekendTimeWithinInterval])

    weekendDay = nextSaturday(weekendDay)
  }

  return weekends
}

export default getWeekends;
